// src/components/inputs/AutoExpandTextarea.jsx
import React, { useEffect, useRef } from 'react';

export default function AutoExpandTextarea({
  value,
  onChange,
  placeholder,
  className,
  maxVh = 0.4,
  minPx = 38,          // 👈 ensure floor matches Send button height
  ...rest
}) {
  const ref = useRef(null);

  const adjust = (el) => {
    if (!el) return;
    const prev = el.style.transition;
    el.style.transition = 'none';
    el.style.height = 'auto';

    const maxPx = Math.floor(window.innerHeight * maxVh);
    // scrollHeight includes padding (not borders). With border-box, height includes borders too.
    const contentH = el.scrollHeight;
    const capped = Math.min(contentH, maxPx);

    // 👇 Hard floor so it never looks taller than the button at rest
    const next = Math.max(capped, minPx);
    el.style.height = next + 'px';
    el.style.overflowY = contentH > maxPx ? 'auto' : 'hidden';

    requestAnimationFrame(() => {
      el.style.transition = prev || 'height 120ms ease';
    });
  };

  useEffect(() => {
    adjust(ref.current);
    const onResize = () => adjust(ref.current);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    adjust(ref.current);
  }, [value]);

  return (
    <textarea
      ref={ref}
      className={className}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      rows={1}
      {...rest}
    />
  );
}
